<template>
  <div class="bubble-container">
    <div
      v-for="bubble in activeBubbles"
      :key="bubble.id"
      class="confirm-bubble"
      :style="getBubbleStyle(bubble)"
      :class="getBubbleClass(bubble)"
    >
      <div class="bubble-content">
        <div class="bubble-icon">💝</div>
        <div class="bubble-text">{{ bubble.message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceiveConfirmBubbles',
  data () {
    return {
      activeBubbles: [],
      bubbleIdCounter: 0
    }
  },
  methods: {
    // 显示新气泡
    showBubble (message = '对方收到了你的想念') {
      const bubble = {
        id: this.bubbleIdCounter++,
        message,
        x: this.getRandomX(),
        y: this.getRandomY(),
        phase: 'appearing', // appearing -> showing -> disappearing
        timestamp: Date.now()
      }

      this.activeBubbles.push(bubble)

      // 动画时序控制
      setTimeout(() => {
        bubble.phase = 'showing'
      }, 100)

      setTimeout(() => {
        bubble.phase = 'disappearing'
      }, 3000)

      setTimeout(() => {
        this.removeBubble(bubble.id)
      }, 3500)
    },

    // 移除气泡
    removeBubble (bubbleId) {
      const index = this.activeBubbles.findIndex(b => b.id === bubbleId)
      if (index > -1) {
        this.activeBubbles.splice(index, 1)
      }
    },

    // 获取随机X位置（屏幕宽度范围内，但避免贴边）
    getRandomX () {
      const margin = 60 // 左右留边距
      const maxX = window.innerWidth - 320 - margin // 320是气泡宽度
      return Math.random() * maxX + margin
    },

    // 获取随机Y位置（屏幕顶部往下80%）
    getRandomY () {
      const topMargin = 80 // 顶部留边距，避开状态栏
      const maxY = window.innerHeight * 0.8 - topMargin
      return Math.random() * maxY + topMargin
    },

    // 获取气泡样式
    getBubbleStyle (bubble) {
      return {
        left: bubble.x + 'px',
        top: bubble.y + 'px'
      }
    },

    // 获取气泡CSS类
    getBubbleClass (bubble) {
      return {
        'bubble-appearing': bubble.phase === 'appearing',
        'bubble-showing': bubble.phase === 'showing',
        'bubble-disappearing': bubble.phase === 'disappearing'
      }
    }
  }
}
</script>

<style scoped>
.bubble-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999; /* 最高层级，确保显示在所有内容之上 */
  overflow: hidden;
}

.confirm-bubble {
  position: absolute;
  width: 280px;
  pointer-events: none;
  transform-origin: center;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 清新磨砂玻璃气泡 */
.bubble-content {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.25) 0%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(248, 250, 252, 0.2) 100%
  );
  backdrop-filter: blur(40px) saturate(200%) brightness(1.1);
  -webkit-backdrop-filter: blur(40px) saturate(200%) brightness(1.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow:
    0 25px 50px rgba(255, 255, 255, 0.1),
    0 15px 35px rgba(0, 0, 0, 0.03),
    0 5px 15px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.6),
    inset 0 -1px 0 rgba(255, 255, 255, 0.2);

  /* 苹果级细节 + 磨砂质感 */
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'PingFang SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  letter-spacing: -0.01em;

  /* 增强透明质感 */
  will-change: transform, opacity;
  transform: translateZ(0);
  position: relative;
  overflow: hidden;
}

.bubble-icon {
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 8px rgba(255, 105, 180, 0.4))
          drop-shadow(0 0 12px rgba(255, 255, 255, 0.6));
  animation: iconGlow 2s ease-in-out infinite alternate;
}

.bubble-text {
  font-size: 15px;
  font-weight: 500;
  color: rgba(74, 85, 104, 0.9);
  line-height: 1.3;
  text-shadow:
    0 1px 3px rgba(255, 255, 255, 0.9),
    0 1px 6px rgba(255, 255, 255, 0.4);
  letter-spacing: 0.2px;
}

/* 动画状态 */
.bubble-appearing {
  opacity: 0;
  transform: scale(0.3) translateY(-30px);
}

.bubble-showing {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.bubble-disappearing {
  opacity: 0;
  transform: scale(0.8) translateY(-20px);
  transition: all 0.3s ease-in;
}

/* iPhone特效 - 轻微的弹性效果 */
.bubble-showing .bubble-content {
  animation: bubbleBounce 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@keyframes bubbleBounce {
  0% {
    transform: scale(0.3);
  }
  50% {
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.98);
  }
  100% {
    transform: scale(1);
  }
}

/* 图标柔和发光效果 */
@keyframes iconGlow {
  0% {
    filter: drop-shadow(0 2px 8px rgba(255, 105, 180, 0.4))
            drop-shadow(0 0 12px rgba(255, 255, 255, 0.6));
  }
  100% {
    filter: drop-shadow(0 2px 12px rgba(255, 105, 180, 0.6))
            drop-shadow(0 0 20px rgba(255, 255, 255, 0.8));
  }
}

/* 移动端优化 - 保持磨砂质感 */
@media (max-width: 480px) {
  .confirm-bubble {
    width: 260px;
  }

  .bubble-content {
    padding: 14px 18px;
    border-radius: 20px;
    backdrop-filter: blur(35px) saturate(180%) brightness(1.1);
    -webkit-backdrop-filter: blur(35px) saturate(180%) brightness(1.1);
    background: linear-gradient(135deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.18) 50%,
      rgba(248, 250, 252, 0.25) 100%
    );
  }

  .bubble-icon {
    font-size: 22px;
  }

  .bubble-text {
    font-size: 14px;
    color: rgba(74, 85, 104, 0.95);
  }
}

/* 超小屏幕适配 - 保持透明质感 */
@media (max-width: 360px) {
  .confirm-bubble {
    width: 240px;
  }

  .bubble-content {
    padding: 12px 16px;
    gap: 10px;
    backdrop-filter: blur(30px) saturate(170%) brightness(1.1);
    -webkit-backdrop-filter: blur(30px) saturate(170%) brightness(1.1);
    background: linear-gradient(135deg,
      rgba(255, 255, 255, 0.35) 0%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(248, 250, 252, 0.28) 100%
    );
  }

  .bubble-icon {
    font-size: 20px;
  }

  .bubble-text {
    font-size: 13px;
    color: rgba(74, 85, 104, 1);
    text-shadow:
      0 1px 2px rgba(255, 255, 255, 1),
      0 1px 4px rgba(255, 255, 255, 0.6);
  }
}

/* 磨砂玻璃光影效果 - 清新透明质感 */
.bubble-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(180deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.1) 60%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 24px 24px 0 0;
  pointer-events: none;
}

/* 添加底部柔和光晕 */
.bubble-content::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30%;
  background: linear-gradient(0deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 0 0 24px 24px;
  pointer-events: none;
}

@media (max-width: 480px) {
  .bubble-content::before {
    border-radius: 20px 20px 0 0;
  }

  .bubble-content::after {
    border-radius: 0 0 20px 20px;
  }
}
</style>
